'use client'

import s from './page.module.scss';
import {Container} from "@/app/[locale]/common/components/Container/Container";
import {Breadcrumbs} from "@/app/[locale]/common/components/Breadcrumbs/Breadcrumbs";
import {
    MARINE_VESSELS_PAGE_LABELS,
} from "../../common/constants/industries";
import React from "react";
import main from '@/app/[locale]/common/assets/images/slider-main/slide_1.webp';
import {TitleImageSection} from "@/app/[locale]/common/components/TitleImageSection/TitleImageSection";
import {ContactUs} from "@/app/[locale]/common/components/ContactUs/ContactUs";
import {Title} from "@/app/[locale]/common/components/Title/Title";
import {ParagraphLine} from "@/app/[locale]/common/components/ParagraphLine/ParagraphLine";
import {ConfirmIcon} from "@/app/[locale]/common/assets/ConfirmIcon/ConfirmIcon";
import Image from "next/image";
import system_data from '../../common/assets/images/industires/marine-vessels/telematic-data.webp';
import {Table} from "@/app/[locale]/common/components/Table/Table";
import {
    TControlledParametersCardContent,
    TControlledParametersCardContentWithIcon,
} from "@/app/[locale]/industries/marine-vessels/types";
import {SliderBlock} from "@/app/[locale]/common/components/SliderBlock/SliderBlock";
import {DieselGeneratorSlideCard} from "@/app/[locale]/common/components/DieselGeneratorSlideCard/DieselGeneratorSlideCard";
import {TDieselGeneratorSlideCardProps} from "@/app/[locale]/common/components/DieselGeneratorSlideCard/types";
import {useTranslations} from "next-intl";
import {FuelIcon} from "@/app/[locale]/common/assets/FuelIcon/FuelIcon";
import {HumonIcon} from "@/app/[locale]/common/assets/HumonIcon/HumonIcon";
import {EngineCheckIcon} from "@/app/[locale]/common/assets/EngineCheckIcon/EngineCheckIcon";
import {DataMonitoringIcon} from "@/app/[locale]/common/assets/DataMonitoringIcon/DataMonitoringIcon";
import slide1_marine_vessels
    from "@/app/[locale]/common/assets/images/industires/marine-vessels/slider/slide1-marine-vessels.webp";
import slide2_marine_vessels
    from "@/app/[locale]/common/assets/images/industires/marine-vessels/slider/slide2-marine-vessels.webp";
import slide3_marine_vessels
    from "@/app/[locale]/common/assets/images/industires/marine-vessels/slider/slide3-marine-vessels.webp";


export default function MarineVessels() {
    const t = useTranslations('MarineVesselsPage');

    const remoteMonitoringIcons = [FuelIcon, HumonIcon, EngineCheckIcon, DataMonitoringIcon];
    const remoteMonitoringData = t.raw('remoteMonitoringBlock.cardsList').map((item: TControlledParametersCardContent, index: number) => ({...item, Icon: remoteMonitoringIcons[index]}));

    const casesImages = [slide1_marine_vessels, slide2_marine_vessels, slide3_marine_vessels];
    const casesData = t.raw('cases.data').map((item: {task: string, label: string, solution: string}, index: number) => ({...item, image: casesImages[index]}));

    return (
        <div className={s.marineVessels}>
            <Container>
                <Breadcrumbs crumb={[t.raw('breadcrumbs.INDUSTRIES'), t.raw('breadcrumbs.MARINE_VESSELS')]}/>

                <TitleImageSection
                    title={t('titleImageSection.title')}
                    image={main}
                />

                <div className={s.marineVessels_remoteMonitoring}>
                    <Title title={MARINE_VESSELS_PAGE_LABELS.REMOTE_MONITORING} />

                    <div className={s.marineVessels_remoteMonitoring_textContainer}>
                        {
                            t.raw('remoteMonitoringBlock.textList').map((item: string, index: number) => (
                                <ParagraphLine key={index} className={s.marineVessels_remoteMonitoring_text}>
                                    { item }
                                </ParagraphLine>
                            ))
                        }
                    </div>

                    <div className={s.marineVessels_remoteMonitoring_cardsContainer}>
                        {
                            remoteMonitoringData.map((item: TControlledParametersCardContentWithIcon, index: number) => (
                                <div key={index} className={`${s.marineVessels_remoteMonitoring_card} ${s.marineVessels_card}`}>
                                    <div className={s.marineVessels_remoteMonitoring_card_iconContainer}>
                                        <item.Icon/>
                                    </div>

                                    <label>{item.label}</label>

                                    <ul className={s.marineVessels_card_content}>
                                        {
                                            item.content.map((el: string, num: number) => (
                                                <li key={num} className={s.marineVessels_card_item}>
                                                    <span><ConfirmIcon/></span>
                                                    {el}
                                                </li>
                                            ))
                                        }
                                    </ul>
                                </div>
                            ))
                        }
                    </div>
                </div>

                {/*<SliderBlock
                    label={t('productsBlock.title')}
                    slidesPerView={4}
                    navigationId={'products'}
                    data={productsData}
                    card={(item, index) => (
                        <ProductsSliderCard
                            key={index}
                            label={item.label}
                            href={(item as TProductsSliderCardProps).href}
                            image={(item as TProductsSliderCardProps).image}
                        />
                    )}
                />*/}


                <div className={s.marineVessels_waterTransport}>
                    <Title title={MARINE_VESSELS_PAGE_LABELS.WATER_TRANSPORT_ADVANTAGES} />

                    <Table data={t.raw('waterTransportBlock.tableData')} headerSize={'large'}  />
                </div>

                <div className={s.marineVessels_parameters}>
                    <Title title={t('parametersBlock.title')}/>

                    <div className={s.marineVessels_parameters_cardsContainer}>
                        {
                            t.raw('parametersBlock.data').map((item: TControlledParametersCardContent, index: number) => (
                                <div key={index}
                                     className={`${s.marineVessels_parameters_card} ${s.marineVessels_card}`}>
                                    <label>{item.label}</label>

                                    <ul className={s.marineVessels_card_content}>
                                        {
                                            item.content.map((el: string, index: number) => (
                                                <li key={index} className={s.marineVessels_card_item}>
                                                    <span><ConfirmIcon/></span>
                                                    {el}
                                                </li>
                                            ))
                                        }
                                    </ul>
                                </div>
                            ))
                        }
                    </div>
                </div>

                <div className={s.marineVessels_systemData}>
                    <Title title={t('systemDataBlock.title')}/>

                    <div className={`${s.marineVessels_systemData_container} ${s.marineVessels_container}`}>
                        <div className={`${s.marineVessels_systemData_imageContainer} ${s.marineVessels_imageContainer}`}>
                            <Image src={system_data} alt={'system_data'}/>
                        </div>

                        <div className={s.marineVessels_systemData_content}>
                            <ParagraphLine>{t('systemDataBlock.text')}</ParagraphLine>
                            <label className={s.marineVessels_label}>{t('systemDataBlock.label')}</label>

                            <ul className={s.marineVessels_systemData_content_list}>
                                {
                                    t.raw('systemDataBlock.list').map((item: string, index: number) => (
                                        <li key={index} className={s.marineVessels_card_item}>
                                            <span><ConfirmIcon/></span>
                                            {item}
                                        </li>
                                    ))
                                }
                            </ul>
                        </div>
                    </div>
                </div>

                <SliderBlock
                    label={t('cases.title')}
                    navigationId={'cases'}
                    data={casesData}
                    card={(item, index) => (
                        <DieselGeneratorSlideCard
                            key={index}
                            label={item.label}
                            task={(item as TDieselGeneratorSlideCardProps).task}
                            solution={(item as TDieselGeneratorSlideCardProps).solution}
                            image={(item as TDieselGeneratorSlideCardProps).image}
                        />)}
                />

                <ContactUs/>
            </Container>
        </div>
    );
};